/**
* author: duxin
* date: 2020/4/7
* describe:
*/

<template>
    <div class="course-chunk">
        <h1 class="p1">{{$t("about.journey")}}</h1>
        <div class="details-wrap">
            <template v-for="item in detailsList">
                <transition name="node">
                    <div class="details" v-show="item.show">
                        <div class="year">{{item.year}}</div>
                        <div class="content">{{item.content}}</div>
                    </div>
                </transition>
            </template>
        </div>
        <div class="content-wrap">
            <div :class="`node ${item.show?'active':''}`" v-for="(item,index) in detailsList"
                 @mouseenter="onMouseenter(index)">
                <div class="line"></div>
                <h3 class="date">{{item.year}}</h3>
                <div class="dot"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "course-chunk",
        data() {
            return {
                detailsList: [
                    {
                        year: 2014,
                        content: this.$t("about.history2014"),
                        show: false,
                    },
                    {
                        year: 2016,
                        content: this.$t("about.history2016"),
                        show: false,
                    },
                    {
                        year: 2017,
                        content: this.$t("about.history2017"),
                        show: false,
                    },
                    {
                        year: 2018,
                        content: this.$t("about.history2018"),
                        show: false,
                    },
                    {
                        year: 2019,
                        content: this.$t("about.history2019"),
                        show: true,
                    },
                ]
            }
        },
        methods: {
            onMouseenter(index) {
                for (let detail of this.detailsList) {
                    detail.show = false;
                }
                this.detailsList[index].show = true;
            }
        }
    }
</script>

<style lang="less" scoped>
@import './chunk';
    @import "../../../style/constant";

    .course-chunk {
        width: @page-width;
        margin: 0 auto;
        padding: 80px 0 120px;
        min-height: 440px;

        h1 {
            text-align: left;
            color: #fff;
            margin-top: 0;
        }

        @media screen and (min-width: 320px) and (max-width: 480px) {
            h1 {
                margin-bottom: 0px;
            }
        }

        .content-wrap {
            display: flex;
            margin: 110px 0;
        }

        @media screen and (min-width: 320px) and (max-width: 480px) {
            .content-wrap {
                overflow-x: auto;
                height: 100px;
                margin: 0;
                padding-bottom: 30px;
            }
        }
        .details-wrap {
            position: relative;
            left: 33%;
            height: 90px;

            .details {
                position: absolute;
                // display: flex;
                // align-items: center;
                color:#FFFFFF;
                .year {
                    font-size: 54px;
                    margin-right: 50px;
                    text-align: center;
                }
                .content {
                    font-size:16px;
                }
            }

            @media screen and (min-width: 320px) and (max-width: 480px) {
                .details {
                    left: 0px;
                    padding:20px 10px;
                    // display: flex;
                    // flex-direction: column;
                    // align-items: center;
                    // position: unset;
                }
            }
        }

        @media screen and (min-width: 320px) and (max-width: 480px) {
            .details-wrap {
                margin-bottom: 0px;
                margin-top: 0px;
                min-height: auto;
                padding-bottom: 0px;
                left: 0;
            }
        }

        .node {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 1;
            color: #435ba1;
            cursor: pointer;

            .date {
                position: absolute;
                bottom: 20px;
                left: 50%;
                font-weight: bold;
                font-style: italic;
                color:#FFFFFF
            }

            .line {
                width: 100%;
                height: 2px;
                background-color: #fff;
            }
            @media screen and (min-width: 320px) and (max-width: 480px) {
                .line {
                    width: 90px;
                }
                .dot {
                    bottom: -16px;
                }
            }
            .dot {
                background-color: #4b8ad8;
                width: 26px;
                height: 26px;
                border-radius: 50%;
                position: absolute;
                left: 50%;

                z-index: 100;
            }
        }
         @media screen and (min-width: 320px) and (max-width: 480px) {
            .node {
                align-items:flex-end;
            }
        }

        .active {
            color: @active-color;
            .date {
                font-size: 24px;
            }
            .dot {
                // transform: scale(1.5);
                background-color: #FFFFFF;
                border: 5px solid #435ba1;

                &::before {
                    display: block;
                    border-width: 13px;
                    transition: all 1s;
                }
            }
        }

        .node-enter {
            transform: translateY(10px);
            opacity: 0;
        }

        .node-enter-active {
            transition: transform .3s, opacity .3s;
        }

        .node-leave-active {
            transform: translateY(-20px);
            opacity: 0;
            transition: transform .3s, opacity .3s;
        }

    }

    @media screen and (min-width: 320px) and (max-width: 480px) {
        .course-chunk {
            width: 90%;
            padding: 60px 0 40px;
            height: 440px;
            .p1 {
                margin: 0px;
            }
        }
    }


</style>
